module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "mattertitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Additional Praise for")])]), _vm._v(" "), _c('p', {
    staticClass: "mattertitle"
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("The Black Book of Outsourcing")])]), _vm._v(" "), _c('p', {
    staticClass: "quotepara"
  }, [_vm._v("“Oracle-On-Demand (formerly Oracle Outsourcing) is the future of how we will develop, deliver and support technology, a service that eliminates the challenge of managing IT. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Black Book of Outsourcing")]), _vm._v(" captures how to get outsourcing results and provides invaluable advice for leaders who are trying to drive tighter execution within their organizations.”")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Juergen Rottler")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Executive Vice President")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Oracle Corporation")]), _vm._v(" "), _c('p', {
    staticClass: "quotepara"
  }, [_vm._v("“The code for outsourcing management has been broken and the secrets for success are here in this book. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Black Book of Outsourcing")]), _vm._v(" has it all. This book will surely be a classic.”")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("John Steele")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Group Director")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("British Telecom/Yahoo")]), _vm._v(" "), _c('p', {
    staticClass: "quotepara"
  }, [_vm._v("“Brown & Wilson deliver on the best, most innovative, new practices all aimed at helping one and all survive, manage, and lead in this new economy.”")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Joann Martin")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Vice President")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Pitney Bowes Management Services")]), _vm._v(" "), _c('p', {
    staticClass: "quotepara"
  }, [_vm._v("“As more and more companies embrace offshoring solutions, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Black Book of Outsourcing")]), _vm._v(" should become a useful aid to the business person looking to navigate the industry with success.”")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Raj Patil")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Senior Vice President")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Marketing and Sales Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("MphasiS Corporation")]), _vm._v(" "), _c('p', {
    staticClass: "quotepara"
  }, [_vm._v("“Outsourcing is a business imperative in our interconnected and interdependent world. Organizations who successfully leverage its power create value for their stakeholders. This book will help you master that destiny.”")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Shiv Nadar")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Founder and Chief Executive Officer")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("HCL Technologies")]), _vm._v(" "), _c('p', {
    staticClass: "quotepara"
  }, [_vm._v("“The exceptional concepts in this book enabled us to build more products and increase services to clients, all while reducing costs.”")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Mark A. Stiffler")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("President and CEO")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Synygy Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "quotepara"
  }, [_vm._v("Business leaders hoping to understand the concerns, challenges and motivating forcues behind the subject of global sourcing will find "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Black Book of Outsourcing")]), _vm._v(" to be an extremely valuable and important tool.”")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Dilip R. Vellodi")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Chief Executive Officer")]), _vm._v(" "), _c('p', {
    staticClass: "quotesource"
  }, [_vm._v("Sutherland Global Services")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fedd8d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Frontmatter.vue
// module id = 60
// module chunks = 0